<template>
    <!-- ABLLS-R -->
    <div class="shehuigongnengkaifake">
      <CertQuery :logo="Logo15" :type="'ablls'" :color="'#294db0'" />
    </div>
  </template>
  
  <script>
  import CertQuery from '../component/certQuery.vue'
  import Logo15 from '@/assets/images/logo15.jpg'
  
  export default {
    name: 'SheHuiGongNengKaiFa',
    components: {
      CertQuery
    },
    data() {
      return {
        Logo15
      }
    }
  }
  </script>
  